import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RouterEvent, NavigationEnd, ActivatedRoute } from '@angular/router';

import { LanguageService } from '../../services/language.service';
import { urlWithoutHeaderAndFooter } from '../../constants/special-urls.const';
import { Title } from '@angular/platform-browser';
import {
  AuthenticationService,
  RouterEventsService
} from '@core-argos-angular-artifact/core';
import {
  ArgosAlertService,
  Notification
} from '@core-argos-angular-artifact/components';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'my-account-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit, OnDestroy {
  isLoading: boolean;

  showHeader = true;

  showFooter = true;

  private readonly ngUnsubscribe: Subject<any> = new Subject();

  constructor(
    private readonly languageService: LanguageService,
    private readonly routerEventsService: RouterEventsService,
    private readonly authService: AuthenticationService,
    private readonly alertService: ArgosAlertService,
    private readonly title: Title,
    private readonly route: ActivatedRoute
  ) {
    this.manageLanguageByParams();
  }

  ngOnInit(): void {
    this.manageInitRouterEvents();
    this.manageEndRouterEvents();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next('');
    this.ngUnsubscribe.complete();
  }

  logout(): void {
    this.isLoading = true;
    this.authService
      .logout()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        error: () => {
          this.alertService.showErrorNotification({
            text: _('errors.default')
          } as Notification);
        }
      });
  }

  private manageInitRouterEvents() {
    this.routerEventsService
      .initChangeRoute()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.isLoading = true;
      });
  }

  private manageEndRouterEvents() {
    this.routerEventsService
      .endChangeRoute()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((route: RouterEvent) => {
        this.isLoading = false;
        if (route instanceof NavigationEnd) {
          this.managePageStructure(route);
          const text =
            route.url === '/'
              ? 'MyAccount'
              : `MyAccount - ${route.url.substring(1)}`;
          this.title.setTitle(text);
        }
      });
  }

  private managePageStructure(route: RouterEvent) {
    if (
      urlWithoutHeaderAndFooter.some((data: string) => route.url.includes(data))
    ) {
      this.showHeader = false;
      this.showFooter = false;
    } else {
      this.showHeader = true;
      this.showFooter = true;
    }
  }

  private manageLanguageByParams() {
    this.route.queryParams.subscribe(params => {
      const paramLocales = params.ui_locales ? params.ui_locales : null;
      this.languageService.init(paramLocales);
      if (paramLocales) {
        localStorage.setItem('locales', paramLocales);
      }
    });
  }
}
